// Enable image expansion on click for product detail pages
function initProductImageExpand() {
  // Find all product media items with popup functionality
  const mediaItems = document.querySelectorAll('[data-media-popup]');

  mediaItems.forEach(function (mediaItem) {
    const mediaImage = mediaItem.querySelector('.media-image');
    const expandButton = mediaItem.querySelector('[data-model-main-head]');

    if (mediaImage && expandButton) {
      // Add cursor pointer style to indicate clickability
      mediaImage.style.cursor = 'pointer';

      // Add click event listener to the image
      mediaImage.addEventListener('click', function (event) {
        event.preventDefault();
        // Trigger the expand button click
        expandButton.click();
      });
    }
  });
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function () {
  initProductImageExpand();
});

// Re-initialize when Shopify sections are loaded (for theme editor)
document.addEventListener('shopify:section:load', function () {
  initProductImageExpand();
});
